import React from 'react';
import { FiFolder, FiChevronRight } from 'react-icons/fi';

const months = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

const MonthlyFolderCard = ({ month, year, count, onClick, isVideo = false, customName, summary }) => {
    const monthName = months[month - 1] || `Month ${month}`;
    const label = customName || `${monthName} ${year}`;
    const isLatest = !customName && month === new Date().getMonth() + 1 && year === new Date().getFullYear();

    // Determine subtitle text
    let subtitleText;
    if (summary) {
        subtitleText = summary;
    } else if (customName) {
        subtitleText = `${count} ${isVideo ? 'video' : 'file'}${count !== 1 ? 's' : ''}`;
    } else {
        subtitleText = `${count} ${isVideo ? 'video' : 'photo'}${count !== 1 ? 's' : ''} stored`;
    }

    return (
        <div
            onClick={onClick}
            className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer p-5 border border-gray-100 hover:border-primaryDark/30 group"
        >
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-xl bg-primaryDark/10 flex items-center justify-center group-hover:bg-primaryDark/20 transition-colors">
                        <FiFolder className="text-primaryDark text-2xl" />
                    </div>
                    <div>
                        <div className="flex items-center gap-2">
                            <span className="text-lg font-semibold text-textPrimary">{label}</span>
                            {isLatest && (
                                <span className="text-[10px] font-bold uppercase tracking-wider bg-primaryDark text-white px-2 py-0.5 rounded">
                                    Latest
                                </span>
                            )}
                        </div>
                        <p className="text-sm text-textMuted">{subtitleText}</p>
                    </div>
                </div>
                <FiChevronRight className="text-textMuted group-hover:text-primaryDark group-hover:translate-x-1 transition-all text-xl" />
            </div>
        </div>
    );
};

export default MonthlyFolderCard;